export const TAG_MATCH_KEYS = ["taglead", "tagcliente"];

export const TAG_CONDITION_FORM_DEFS = {
  taglead: {
    type: "tag",
    label: "Tags da solicitação",
    helperText: "A solicitação tem as tags escolhidas — todas ou pelo menos uma.",
    catalog: "client_tags",
    source: "lead",
  },
  tagcliente: {
    type: "tag",
    label: "Tags do cadastro do cliente",
    helperText: "O cadastro do cliente tem as tags escolhidas — todas ou pelo menos uma.",
    catalog: "client_tags",
    source: "client",
  },
};

export function isTagMatchConditionKey(key) {
  return TAG_MATCH_KEYS.includes(String(key || ""));
}

function normalizeTagName(value) {
  return String(value ?? "")
    .trim()
    .replace(/\s+/g, " ");
}

export function splitAutomationTags(raw) {
  if (raw == null || raw === "") return [];
  const list = Array.isArray(raw)
    ? raw
    : String(raw)
        .split(/[;,]/g)
        .map((s) => s.trim());
  const seen = new Set();
  const out = [];
  for (const item of list) {
    const name = normalizeTagName(item);
    if (!name) continue;
    const key = name.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(name);
  }
  return out;
}

export function normalizeTagMatchValue(expected) {
  if (expected == null || expected === "") {
    return { tags: [], mode: "any" };
  }
  if (typeof expected === "object" && !Array.isArray(expected)) {
    const tags = splitAutomationTags(expected.tags ?? expected.value ?? expected.values);
    const mode = String(expected.mode || expected.match || "any").toLowerCase() === "all" ? "all" : "any";
    return { tags, mode };
  }
  return { tags: splitAutomationTags(expected), mode: "any" };
}

export function formatTagMatchLabel(value) {
  const { tags, mode } = normalizeTagMatchValue(value);
  if (!tags.length) return "";
  const prefix = mode === "all" ? "Todas" : "Pelo menos uma";
  return `${prefix}: ${tags.join(", ")}`;
}

export function isTagMatchValue(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  return Array.isArray(value.tags) || value.mode === "any" || value.mode === "all";
}

export function mergeTagConditionsIntoEventSchema(schema = {}) {
  if (!schema || typeof schema !== "object" || Array.isArray(schema)) {
    return { ...TAG_CONDITION_FORM_DEFS };
  }
  const merged = { ...schema };
  for (const [key, def] of Object.entries(TAG_CONDITION_FORM_DEFS)) {
    const current = merged[key];
    if (!current) {
      merged[key] = def;
      continue;
    }
    if (current.type !== "tag" && current.type !== "tag_match") {
      merged[key] = {
        ...def,
        label: current.label || def.label,
      };
    }
  }
  return merged;
}
